import "./tabbar.css";
import logo from "../../assets/Logo.svg";
import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// import { AuthContext } from "../../lib/AuthProvider";
// import { useAuth0 } from "@auth0/auth0-react";
// import { DataContext, TrialStudy } from "../../context/DataContext";

import MenuItem from "../menuitem/MenuItem";
import Dropdown from "../dropdown/Dropdown";
import MainMenu from "../mainmenu/MainMenu";

import { DashboardIcon } from "../../assets/DashboardIcon";
import { ParticipantsIcon } from "../../assets/ParticipantsIcon";
import { DevicesIcon } from "../../assets/DevicesIcon";
import { UsersIcon } from "../../assets/UsersIcon";
import StudyDropdown from "../studies-dropdown/StudiesDropdown";

import { useSharedState } from '../../context/sharedState';

import { useAuthenticator } from '@aws-amplify/ui-react';


const TabBar = () => {
  // const { user } = useContext(AuthContext);
  // const { logout } = useAuth0();

  type SignInDetails = {
    loginId: string;
    authFlowType: "USER_SRP_AUTH" | string; // Assuming "USER_SRP_AUTH" is a constant value, but it could be any string
  };
  
  type user = {
    username: string;
    userId: string;
    signInDetails?: SignInDetails;
  };


  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { isMobile } = useSharedState();

  // const { setSelectedStudy } = useContext(DataContext);

  const location = useLocation();
  const navigate = useNavigate();

  const [selectedTab, setSelectedTab] = useState(() => {
    switch (location.pathname) {
        case "/":
            return 0;
        case "/participants":
            return 1;
        case "/sensors":    
            return 2;
        case "/users":
            return 3;
        default:
            return 0; // Default state if none of the paths match
    }
  });
  


  return (
    <div className="tab-bar">
      <img alt="website logo" className="logo" src={logo}></img>
      
      {isMobile ? 
        <></>
      : 
      
      <div className="links">

        <MainMenu
          isSelected={selectedTab === 0}
          icon={
            <DashboardIcon
              fill={
                selectedTab === 0 ? getComputedStyle(document.documentElement).getPropertyValue("--on-surface") : getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")
              }
            ></DashboardIcon>
          }
          value={"Dashboard"}
          onClicked={() => {
            setSelectedTab(0);
            navigate("/");
          }}
        ></MainMenu>

        <MainMenu
          isSelected={selectedTab === 1}
          icon={
            <ParticipantsIcon
              fill={
                selectedTab === 1 ? getComputedStyle(document.documentElement).getPropertyValue("--on-surface") : getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")
              }
            ></ParticipantsIcon>
          }
          value={"Participants"}
          onClicked={() => {
            setSelectedTab(1);
            navigate("/participants");
          }}
        ></MainMenu>

        <MainMenu
          isSelected={selectedTab === 2}
          icon={
            <DevicesIcon
              fill={
                selectedTab === 2 ? getComputedStyle(document.documentElement).getPropertyValue("--on-surface") : getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")
              }
            ></DevicesIcon>
          }
          value={"Sensors"}
          onClicked={() => {
            setSelectedTab(2);
            navigate("/sensors");
          }}
        ></MainMenu>

        <MainMenu
          isSelected={selectedTab === 3}
          icon={
            <UsersIcon
              fill={
                selectedTab === 3 ? getComputedStyle(document.documentElement).getPropertyValue("--on-surface") : getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")
              }
            ></UsersIcon>
          }
          value={"Users"}
          onClicked={() => {
            setSelectedTab(3);
            navigate("/users");
          }}
        ></MainMenu>
        
      </div>
      
      }
      
      <div className="profile-host">

        {/* <Dropdown
          items={["Lassen", "Sierra"]}
          onItemSelected={(index) => {
            if (index === 0) {
              setSelectedStudy(TrialStudy.Lassen);
            } else {
              setSelectedStudy(TrialStudy.Sierra);
            }
          }}
        ></Dropdown> */}
        <StudyDropdown />

        <div className="profile">
          {user && (
            <>
              <div className="placeholder">{user.signInDetails?.loginId && <span className="label-small">{user.signInDetails?.loginId.charAt(0).toUpperCase()}</span>}</div>
              
              <div className="label-medium name">Profile</div>

              <div className="actions">
                <div className="actions-container">
                  <div className="list-item title-small">{user.signInDetails?.loginId}</div>
                  <div className="divider"></div>
                  <MenuItem 
                    value="Settings" 
                    onClicked={() => {
                      navigate("/profile");   // navigate(-1) goes back to the previous page // Use this in profile page
                    }}
                  ></MenuItem>
                  <div className="divider"></div>
                  <MenuItem
                    value="Logout"
                    onClicked={signOut}
                  ></MenuItem>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default TabBar;
